function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Configuration } from "../Shared/Configuration";
import { Ajax } from "./Ajax";
export var CommunicationService = /*#__PURE__*/function () {
  function CommunicationService() {
    _classCallCheck(this, CommunicationService);

    var config = new Configuration();
    this._appRoot = config.GetAppRoot();
  }

  _createClass(CommunicationService, [{
    key: "SendEmail",
    value: function SendEmail(formData) {
      var url = "".concat(this._appRoot, "/Api/CommunicationApi/SendSimpleEmail");
      return Ajax.Post(url, formData);
    }
  }, {
    key: "GetEmailTemplate",
    value: function GetEmailTemplate(emailTemplateId) {
      var url = "".concat(this._appRoot, "/Api/CommunicationApi/GetEmailTemplate?emailTemplateId=").concat(emailTemplateId);
      return Ajax.Get(url);
    }
  }]);

  return CommunicationService;
}();